<template>
	<div>
		<h3>{{ $t('monte.congelation.reservations_non_prepares') }}</h3>
        <CustomTable
            id_table="dose_reservations"
            ref="table"
            :items="reservations"
            :busy.sync="table_busy"
            primaryKey="semencedose_id"
            :hide_if_empty="true"
            :hrefsRoutes="config_table_hrefs"
            :externSlotColumns="['nb_expedition']"
        >
            <template v-slot:[`custom-slot-cell(nb_expedition)`]="{ data }">
            	<a href="#" @click.prevent="setUpDoseDetail">{{ data.nb_expedition }}</a>
            </template>
    	</CustomTable>

		<h3>{{ $t('monte.congelation.expeditions') }}</h3>
        <CustomTable
            id_table="dose_expeditions"
            ref="table"
            :items="expeditions"
            :busy.sync="table_busy"
            primaryKey="semencedose_id"
            :hide_if_empty="true"
            :hrefsRoutes="config_table_hrefs"
            :externSlotColumns="['nb_expedition']"
        >
            <template v-slot:[`custom-slot-cell(nb_expedition)`]="{ data }">
            	<a href="#" @click.prevent="setUpDoseDetail">{{ data.nb_expedition }}</a>
            </template>
    	</CustomTable>
	</div>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"

	export default {
		name: 'DoseDetail',
		mixins: [Congelation],
		props: ['dose'],
		data () {
			return {
				table_busy: false,
				reservations: [],
				expeditions: [],
				config_table_hrefs: {
					'demandeur.tiers_rs': {
						routeUniqueName: 'DemandeurFiche',
						routeName: 'tiersFiche',
						params: {
							tiers_id: 'demandeur.tiers_id'
						}
					},
					'destinataire.tiers_rs': {
						routeUniqueName: 'DestinataireFiche',
						routeName: 'tiersFiche',
						params: {
							tiers_id: 'destinataire.tiers_id'
						}
					},
				}
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.table_busy = true
				this.reservations = await this.getDoseReservations(this.dose.semencedose_id)
				this.expeditions = await this.getDoseExpeditions(this.dose.semencedose_id)
				this.table_busy = false
			},
		},

		components: {
			CustomTable : () => import('GroomyRoot/components/Table/CustomTable')
		}
	}

</script>